import * as React from 'react'
import {H1} from '@frontrow/console/src/components/typography'
import {Link} from '@frontrow/console/src/components/ui/link'
import {
  type ItemT,
  type StoreCategoryT,
  gradeToNumber
} from '@frontrow/console/src/entities/models/item'
import {type StoreCategoryVariationT} from '@frontrow/console/src/entities/models/store-category-variation'

import ErrorAlert from '@frontrow/console/src/components/common/error-alert'
import Form from '@frontrow/console/src/components/pages/piggy-store-page/form'
import {type ItemParamsT} from '@frontrow/console/src/helpers/api-items'
import {Routes} from '@frontrow/console/src/routers/routes'

type Props = {
  item: ItemT
  error: string | undefined | null
  updateItem: (itemId: number, item: ItemParamsT) => void
  storeCategoryVariations: Array<StoreCategoryVariationT>
}

export default function EditItem(props: Props): React.ReactElement {
  const {item, error, updateItem, storeCategoryVariations} = props
  const errorNode = error !== null && error !== undefined ? <ErrorAlert>{error}</ErrorAlert> : null

  const onSubmit = (
    name: string,
    category: string,
    storeCategory: StoreCategoryT,
    price: number,
    isHidden: boolean,
    minGrade: number,
    maxGrade: number
  ) =>
    updateItem(item.id, {
      name,
      category,
      storeCategory,
      price,
      isHidden,
      minGrade,
      maxGrade
    })

  return (
    <div>
      <H1>Edit Item</H1>
      <Link href={Routes.items.items()} reactRouter>
        Back
      </Link>
      {errorNode}
      <Form
        name={item.name}
        locizeKey={item.locizeKey}
        category={item.category}
        storeCategory={item.storeCategory}
        storeCategoryVariations={storeCategoryVariations}
        price={item.price}
        isHidden={item.isHidden}
        minGrade={gradeToNumber(item.minGrade)}
        maxGrade={gradeToNumber(item.maxGrade)}
        onSubmit={onSubmit}
      />
    </div>
  )
}
